(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
var View = require('./views/api-error')
  , debug = require('../lib/debug')('custom sync')

module.exports = function () {
  var view = new View()
    , lastTimeout

  debug('Setting Backbone.sync to parentSyncMethod')
  var parentSyncMethod = Backbone.sync

  Backbone.sync = function (method, model, options) {
    debug('sync called')
    clearTimeout(lastTimeout)

    var currentError = function () {}
      , currentSuccess = function () {}

    if (options.error) {
      currentError = options.error
    }

    if (options.success) {
      currentSuccess = options.success
    }

    options.error = function (xhr, textStatus, errorThrown) {
      debug('sync error - xhr status ' + xhr.status)

      currentError(xhr, textStatus, errorThrown)

      // No status is returned if the API is inaccessible
      if (xhr.status === 0) {
        view.render()
        lastTimeout = setTimeout(function () {
          options.xhr = undefined
          parentSyncMethod(method, model, options)
          debug(method, model, options)
        }, 2000)
      }
    }

    options.success = function (xhr, textStatus, errorThrown) {
      debug('sync succeeded')

      currentSuccess(xhr, textStatus, errorThrown)
      view.remove()
    }

    parentSyncMethod(method, model, options)
  }
}

}).call(this,require('_process'),typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/admin/source/js/app/api-error/index.js","/admin/source/js/app/api-error")
//# sourceMappingURL=data:application/json;charset:utf-8;base64,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